module.exports = __webpack_public_path__ + "img/box_whole.c432680b.png";